import { Document } from './document.do';

// DTO Object for representing receipt
export class Receipt extends Document {
  // The receipt number
  public number: number;
}
